module.exports = __webpack_public_path__ + "home-partner-image-ui-ux.fbO8yFzC.svg";